import Button from "../components/button/Button"
import FAQItem from "../components/questions/Questions"
import styles from "./ForthScreen.module.css"

const ForthScreen = () => {
    return <>
        <div className={styles.title}>שאלות תשובות</div>
        <div className={styles.description}>
            אני זוכרת שבתחילת הדרך שלי עלו לי המון שאלות וחששות - אני בטוחה שגם לך יש כמה. 
            ריכשתי עבורך מקבץ שאלות (לחצי על השאלה כדי שהתשובה תפתח)
        </div>
        
        <FAQItem 
            question="האם אני באמת יכולה להצליח בתחום אם אין לי ניסיון קודם?" 
            answer="כל מתחילה מרגישה בדיוק ככה. את לא לבד בחששות האלה. מה שחשוב לדעת הוא שהניסיון נבנה, אבל התשוקה והנחישות שלך - זה מה שבאמת יקבע את ההצלחה. כשיש לך את הרצון האמיתי לשירות ולהצלחה, הטכניקות נלמדות בדרך. את מגיעה עם המוטיבציה, ואני אדאג לתת לך את כל הכלים והליווי שיעזרו לך להפוך את הפוטנציאל הזה למציאות."
        />
        
        <FAQItem 
            question="איך אני יודעת שאני לא אכשל כמו קורסים שעשיתי בעבר?" 
            answer="את מגיעה עם ניסיון של אכזבות קודמות, וזה לגמרי מובן שיש לך חששות. מה שיהיה שונה הפעם הוא שאת לא תישארי לבד עם השאלות שלך. העבודה אצלנו היא בקבוצות קטנות של עד 6 תלמידות, כך שכל אחת מקבלת תשומת לב אישית. את תקבלי ליווי לפני, במהלך ואחרי הקורס. כשיש לך מישהי שמאמינה בך ונותנת לך את הכלים הנכונים, התוצאות שונות לגמרי."
        />
        
        <FAQItem 
            question="איך אני אדע שאני באמת מוכנה לצאת לעבוד אחרי הקורס?" 
            answer="השאלה הזו מראה שאת חושבת נכון - חשוב לצאת מוכנה ובטוחה. הקורס בנוי כך שתסיימי אותו עם הכלים המקצועיים והביטחון הנפשי שתצטרכי. את תקבלי הכשרה טכנית מקיפה, אבל גם הדרכה בניהול לקוחות ובהיבטים העסקיים. בנוסף, תוכלי לבקר בקליניקה ולראות איך המקצוע נראה בפועל. כשתסיימי, את תדעי בדיוק מה הצעד הבא שלך."
        />
        
        <FAQItem 
            question="זה לא מפחיד את כל התחרות שיש בתחום?" 
            answer="גם אני חששתי מאותו הנושא בדיוק! מה שעזר לי להכנס לתחום למרות החשש הזה היא המחשבה שככל שיש יותר תחרות זה אומר שיש יותר ביקוש - וכמו שיש הרבה מתחרות יש הרבה לקוחות - עם הזמן את תמצאי את קהל הלקוחות שלך!"
        />
        
        <FAQItem 
            question="כמה זמן ייקח לי עד שאתחיל להרוויח כסף מהתחום?" 
            answer="את שואלת שאלה כנה וחשובה, ואני אתן לך תשובה כנה. ההתחלה דורשת סבלנות והשקעה - זה לא יהיה קסם מיידי. בדרך כלל, עם עבודה עקבית ויישום הכלים שתלמדי, את תתחילי לראות תוצאות כלכליות תוך מספר חודשים. החשוב הוא להיות מוכנה לתקופת הבנייה הראשונית ולא להתמוטט ברגעי הקושי. כשיש לך את הכלים הנכונים והליווי הנכון, התהליך מתקצר."
        />
        
        <FAQItem 
            question="מה קורה אם אני צריכה עזרה אחרי שהקורס נגמר?" 
            answer="חשוב שתדעי! - את לא נשארת לבד כשהקורס מסתיים. הליווי ממשיך גם אחרי - אני והצוות כאן לכל שאלה כשאת נתקעת או כשאת צריכה חיזוק וכיוון ולכל חשש שיש לך עד שאת מרגישה בטוחה בעצמך."
        />
        

           <Button text="נתי, קחי אותי להרשמה!"/>
    </>
}

export default ForthScreen